// extracted by mini-css-extract-plugin
export default {"textarea":"Textarea_textarea__HBh1J"};